module.exports = {"511771200":"斌郎乡","511771201":"幺塘乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/511771.json
// module id = 2378
// module chunks = 0